import {AuthState} from "@models/user";
import {AuthActionTypes} from '@actions/auth';
import {Reducer} from "redux";

const initialState: AuthState = {
  authenticated: false,
  access_token: null,
  user_info: {},
};

const reducer: Reducer<AuthState> = (state = initialState, action) => {
  
  switch (action.type) {
    case AuthActionTypes.LOGIN_SUCCESS:
      const payload = action.payload;
      const response = payload.access_token ? {
        access_token: payload.access_token,
        title: payload.title,
        user_info: payload.user_ifo
      } : payload;
      
      return {
        ...state,
        authenticated: true,
        ...response,
        error: ""
      };
    
    case AuthActionTypes.LOGIN_ERROR:
      return {
        ...state,
        ...{"errorMessage": action.payload}
      };
    
    case AuthActionTypes.LOGOUT_SUCCESS:
      localStorage.clear();
      return initialState;
    
    case AuthActionTypes.UPDATE_SUCCESS: {
      const userInfo = action.payload;
      if (userInfo.id === state.user_info.id) {
        let user = JSON.parse(localStorage.getItem('user'));
        user.user_ifo = userInfo;
        localStorage.setItem("user", JSON.stringify(user));
        return {
          ...state,
          user_info: userInfo
        };
      } else {
        return {
          ...state,
        }
      }
    }
    
    case AuthActionTypes.CHANGE_PASSWORD_SUCCESS: {
      return {
        ...state
      }
    }
    
    default:
      if ((action.type.indexOf("_ERROR") != -1) && (action.payload && action.payload.status == 401)) {
        // localStorage.clear();
        return initialState
      }
      return state;
  }
};


export {reducer as authReducer};


export const getIsAuthorized = (state) => state.auth.authenticated